const header = [
  {
    icon: '',
    text: "Medições",
    roles: ['admin', 'super_admin', 'execute'],
    children: [
      {
        icon: '',
        text: 'Lista de Medições',
        to: '/',
        roles: ['admin', 'super_admin', 'execute'],
      },
      {
        icon: '',
        text: 'Criar Medição',
        to: '/execution/create',
        roles: ['admin', 'super_admin']
      }
    ]
  },
  {
    icon: '',
    text: "Departamentos",
    roles: ['admin', 'super_admin'],
    children: [
      {
        icon: '',
        text: 'Lista de Departamentos',
        to: '/departments',
        roles: ['admin', 'super_admin']
      }
    ]
  },
  {
    icon: '',
    text: "Categorias",
    roles: ['admin', 'super_admin'],
    children: [
      {
        icon: '',
        text: 'Lista de Categorias',
        to: '/categories',
        roles: ['admin', 'super_admin']
      }
    ]
  },
  {
    icon: '',
    text: "Consolidações",
    to: "/consolidations",
    roles: ['admin', 'super_admin']
  },
  {
    icon: '',
    text: 'Usuários',
    to: '/users',
    roles: ['admin', 'super_admin']
  },
  {
    icon: '',
    text: "Minha conta",
    to: "/account",
    roles: ['admin', 'super_admin', 'execute'],
  },
  {
    text: "Sair",
    to: "/logout",
    roles: ['admin', 'super_admin', 'execute'],
  }
];

const drawer = header;

const bottom = [
  {
    text: "Home",
    to: "/",
    icon: "$vuetify.icons.home",
    active: true
  },
  {
    text: "Minha Conta",
    to: "/account",
    icon: "$vuetify.icons.user",
    active: true
  },
  {
    text: "Atividade",
    to: "/logout",
    icon: "$vuetify.icons.logout",
    active: true
  }
];

export { header, drawer, bottom };
